import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/stylesheet/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import store from './Redux/store/index';
import { Provider } from 'react-redux';

// Always start from top on browser reload (don't restore previous Reviews scroll)
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
const navigationEntry = performance.getEntriesByType('navigation')[0];
const isBrowserReload = navigationEntry?.type === 'reload';
if (isBrowserReload) {
  sessionStorage.removeItem('dynamicDestinationMenu');
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <div style={{ maxWidth: '1900px', margin: 'auto' }}>
          <App />
        </div>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
